import NewPartnerAndResellerDialogContainer from './new-partner-and-reseller-dialog.container';

export default NewPartnerAndResellerDialogContainer;
